module.exports = __webpack_public_path__ + "img/img-5.28a37f86.png";